<!--
  * @Author: w9013327 v-maijiahua@oppo.com
  * @Date: 2023-06-14 12:33:02
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-10-16 11:37:59
  * @FilePath: \community-backende:\sns-user-frontend\src\components\wap\wapCircleSelector.vue
  * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 -->
<template>
  <!-- 用于占位 -->
  <div
    class="block"
    :style="{
      height: state.keyword ? '64px' : '127px'
    }"
  ></div>
  <el-input 
    v-model="state.keyword"
    :placeholder="$t('search')"
    maxlength="50"
    clearable
  >
    <template #prefix>
      <svg-icon name="icon-search"/>
    </template>
  </el-input>
  <el-tabs
    v-show="!state.keyword" 
    v-model="state.active"
    color="#000"
    title-active-color="var(--text-primary)"
    title-inactive-color="var(--text-secondary)"
    background="var(--background-selection)"
    animated
    :sticky="true"
    :line-width="state.lineWidth"
    :offset-top="offsetTop"
  >
    <el-tab-pane
      v-for="group in state.circleGroup"
      :key="group.categoryId"
      :label="group.name"
      :name="group.categoryId"
    >
      <div class="select-wrap">
        <div  
          v-for="circle in group.circleItemList"
          :key="`${group.categoryId}-${circle.id}` || '0'"
        >
          <div class="recommeded-more" v-if="circle.recommendedTips">
            <svg-icon name="icon-circle"/>
            <span>{{ $t('recommendCircleTips') }}</span>
          </div>
          <template v-else>
            <el-collapse 
              v-if="circle.circleTabItemList?.length && disabledCircle(circle.id).clickAble"
              v-model="state.collapsName" 
              accordion
            >
              <el-collapse-item :name="circle.id || '0'">
                <template #title>
                  <div
                    class="collapse-selector"
                    @click="onCollapse(circle)"
                  >
                    <el-image 
                      v-if="circle.avatar"
                      :src="circle.avatar"
                      fit="cover"
                    />
                    <span>{{ circle.name }}</span>
                  </div>
                </template>
                <div class="circle-tab">
                  <span
                    class="circle-tab-item"
                    v-for="tab in circle.circleTabItemList"
                    :class="selectedCircleTab.id === tab.id ? 'active' : ''"
                    :key="tab.id || 'none'"
                    @click.stop="onSelectCircle(circle, tab)"
                  >{{ tab.name }}</span>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div
              v-else
              class="single-item"
              @click="onSelectCircle(circle)"
            >
              <div class="option-left collapse-selector">
                <el-image 
                  v-if="circle.avatar"
                  :src="circle.avatar"
                  fit="cover"
                />
                <div>
                  <span>{{ circle.name }}</span>
                  <p v-if="circle.id === '0'">{{ $t('myprofileTips') }}</p>
                </div>
              </div>
              <div 
                class="radio" 
                :class="circle.id === selectedCircle.id ? 'checked-radio' : ''">
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
  <div class="select-wrap search-wrap" v-if="state.keyword">
    <template v-if="state.searchList.length">
      <div  
        v-for="circle in state.searchList"
        :key="circle.id || '0'"
      >
        <div class="recommeded-more" v-if="circle.recommendedTips">
          <svg-icon name="icon-circle"/>
          <span>{{ $t('recommendCircleTips') }}</span>
        </div>
        <template v-else>
          <el-collapse 
            v-if="circle.circleTabItemList?.length"
            v-model="state.collapsName" 
            accordion
          >
            <el-collapse-item :name="circle.id || '0'">
              <template #title>
                <div
                  :value="circle.id || '0'"
                  :label="circle.name"
                  :disabled="true"
                  class="collapse-selector"
                  @click="onCollapse(circle)"
                >
                  <el-image 
                    v-if="circle.avatar"
                    :src="circle.avatar"
                    fit="cover"
                  />
                  <span>{{ circle.name }}</span>
                </div>
              </template>
              <div class="circle-tab">
                <span
                  class="circle-tab-item"
                  v-for="tab in circle.circleTabItemList"
                  :class="selectedCircleTab.id === tab.id ? 'active' : ''"
                  :key="tab.id || 'none'"
                  @click.stop="onSelectCircle(circle, tab)"
                >{{ tab.name }}</span>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div
            v-else
            :value="circle.id || '0'"
            :label="circle.name"
            :disabled="circle.disabled"
            @click="onSelectCircle(circle)"
          >
            <div class="option-left collapse-selector">
              <el-image 
                v-if="circle.avatar"
                :src="circle.avatar"
                fit="cover"
              />
              <div>
                <span>{{ circle.name }}</span>
                <p v-if="circle.id === '0'">{{ $t('myprofileTips') }}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <PageStatus v-else status="noContent" :content="$t('noResult')"/>
  </div>
</template>

<script setup>

import { reactive, watch, watchEffect,getCurrentInstance, onBeforeMount, nextTick, computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'

const { proxy } = getCurrentInstance()
const userStore = useUserStore()
const { uid } = storeToRefs(userStore)
const route = useRoute()

const emit = defineEmits(['change', 'update:selectedCircle', 'update:selectedCircleTab'])

const props = defineProps({
  selectedCircle: {
    type: Object,
    default: ''
  },
  selectedCircleTab: {
    type: Object,
    default: ''
  },
  offsetTop: {
    type: [String, Number]
  },
  circleTabOffsetTop: {
    type: [Number, String]
  },
  poperVisible: {
    type: Boolean
  },
  needRecommendCircle: {
    type: Boolean,
    default: false
  },
  hasProfile: {
    type: Boolean,
    default: true
  }
})

const state = reactive({
  active: 'myCircles',
  keyword: '',
  circleTabId: '',
  collapsName: '',
  lineWidth: 0,
  allCircleList: [],
  searchList: [],
  circleGroup: [],
  circleTabList: [],
  circleTabVisible: false,
})


const disabledCircle = computed(() => (id) => {
  let status = {
    clickAble: true,
    disabled: false
  }
  if (route.query.from === 'product') {
    status = {
      clickAble: !route.query.circleTabId && route.query.circleId === id,
      disabled: !route.query.circleTabId && route.query.circleId !== id
    }
  }
  return status
})

const onSelectCircle = (circle, tab) => {
  if (!disabledCircle.value(circle.id).clickAble) return
  if (circle) {
    sendGaData('publish_new_threads_circle_select', {
      "circle_id": circle.id,
      "circle_name": circle.name,
    })
    // state.selectedCircle = { ...circle }
    emit('update:selectedCircle', circle)
  }
  if (tab) {
    sendGaData('publish_new_threads_circle_select', {
      "circle_id": circle.id,
      "circle_name": circle.name,
      "button_name": tab.name
    })
    emit('update:selectedCircleTab', tab)
  } else {
    emit('update:selectedCircleTab', {})
  }
  emit('change')
  state.circleTabVisible = false
}

const enteryCircleSearch = () => {
  sendGaData('publish_new_threads', {
    "action": "circle search entry"
  })
}

const onCollapse = (val) => {
  // state.collapsName = val.id
  // Object.assign(props.selectedCircle, val)
}


const getAllCircleList = async () => {
  const { code, data, msg } = await proxy.$http.getAllCircles({
    source: 1
  })
  if (code === 200 && data?.length) {
    const myCircle = await getMyCircles()
    let myCircles = {
      categoryId: 'myCircles',
      name: proxy.$t('myCircles'),
      circleItemList: [ ...myCircle ]
    }
    data.forEach(i => {
      addOriginCircleTab(i.circleItemList)
    })
    
    state.circleGroup = [myCircles, ...data]
    state.allCircleList = data.reduce((prev, next) => {
      return [...prev, ...next.circleItemList]
    }, [])
    myCircle.forEach(i => {
      let existCircle = state.allCircleList.some(a => a.id === i.id)
      if (!existCircle) {
        state.allCircleList.push(i)
      }
    })
  }
}

const getMyCircles = async () => {
  const { code, data, msg } = await proxy.$http.getMyCircles({
    source: 1
  })
  if (code === 200 && data?.length) {
    addOriginCircleTab(data)
    let recommendedCircleRes = []
    if (props.needRecommendCircle) {
      recommendedCircleRes = await getRecommendCircle()
    }
    // 是否去除个人主页的选项
    let circleList = data
    if (!props.hasProfile) {
      circleList = circleList.filter((item) => item.id !== '0')
    }
    return [...circleList, ...recommendedCircleRes]
  }
  return []
}

const addOriginCircleTab = (data) => {
  data.forEach(circle => {
    circle.id = circle.id ? circle.id : '0'
    if (circle.circleTabItemList && circle.circleTabItemList.length) {
      circle.circleTabItemList.push({
        id: '',
        name: proxy.$t('none')
      })
    }
  })
}

const getRecommendCircle = async () => {
  const { code, data, msg } = await proxy.$http.getRecommendCircle({
    type: 1
  })
  if (code === 200 && data?.length) {
    const recommendedCircle = data.map(i => {
      const { circleAvatar: avatar, circleId: id, circleName: name, circleTabItemVOS: circleTabItemList } = i || {}
      if (circleTabItemList && circleTabItemList.length) {
        circleTabItemList.unshift({
          id: '',
          name: proxy.$t('none')
        })
      }
      return {
        id,
        name,
        avatar,
        circleTabItemList
      }
    })
    recommendedCircle.unshift({
      recommendedTips: true
    })
    return recommendedCircle
  }
  return []
}

const sendGaData = (name, data) => {
  if (route.params.id) {
    name = name.replace('publish_new_threads', 'edit_thread')
  }
  let params = {
    "screen_name": route.name,
    "thread_category": route.params.type === 'moment' ? 2 : (route.params.type === 'article' ? 1 : 4),
    "thread_id": route.params.id || "",
  }
  proxy.$ga(name, {
    ...params,
    ...data
  })
}

function resetSelected () {
  state.collapsName = ''
  emit('update:selectedCircle', {})
  emit('update:selectedCircleTab', {})
}


watch(() => state.keyword, val => {
  if (val.trim()) {
    state.searchList = state.allCircleList.filter(i => i.name?.toLowerCase().includes(val.trim().toLowerCase()))
  } else {
    state.searchList = []
  }
})


watchEffect(() => {
  state.circleTabId = state.circleTabList.some(i => i.id === props.selectedCircleTab.id) ? props.selectedCircleTab.id : ''
})

onBeforeMount(async () => {

  if (!uid.value) {
    userStore.onShowLoginPopup()
    return
  }
  await getAllCircleList()
  // 来自圈子发布器、选中默认圈子
  if (route.query.circleId) {
    let selectCircle = state.allCircleList.filter((item) => {
      return item.id === route.query.circleId
    })[0]
    if (selectCircle) {
      emit('update:selectedCircle', {
        id: selectCircle.id,
        name: selectCircle.name,
      })
    }
    if (route.query.circleTabId) {
      let selectCircleTab = selectCircle.circleTabItemList.filter((item) => {
        return item.id === route.query.circleTabId
      })[0]
      emit('update:selectedCircleTab', {
        id: selectCircleTab.id,
        name: selectCircleTab.name,
      })
    }
    
    
  }
})

defineExpose({
  state,
  resetSelected
})

</script>

<style lang="postcss" scoped>
.circle-group {
  width: 744px;
  height: 500px;
  overflow: auto;
}
.block {
  position: absolute;
  top: 0;
  width: 100%;
  background-color: #FFF;
  z-index: 10;
}
:deep(.el-scrollbar__view) {
  padding-bottom: 0;
}
.el-tabs {
  margin-top: 127px;
  :deep(.el-tabs__header) {
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 80px);
    margin: 0 auto 18px;
    z-index: 20;
  }
  :deep(.el-tabs__nav-wrap) {
    display: flex;
    align-items: center;
    padding: 0;
    &::after {
      background-color: transparent;
    }
    .el-tabs__item {
      --el-text-color-primary: var(--text-secondary);
      --el-font-size-base: 18px;
      font-family: 'orbit-M';
      padding: 0 16px;
      &:hover {
        color: var(--theme);
      }
    }
    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 0 !important;
    }
    .is-disabled {
      display: none;
    }
    .is-active {
      --el-color-primary: var(--text-primary)
    }
    .el-tabs__active-bar {
      background-color: var(--theme);
    }
    span {
      width: 52px;
      height: 24px;
      text-align: right;
      z-index: 799;
    }
    .el-icon {
      width: 24px;
      height: 24px;
      svg {
        width: 24px;
        height: 24px;
      }
    }
  
    .el-tabs__nav-prev {
      background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 4.84%, #FFFFFF 44.23%);
      text-align: left;
    }
    .el-tabs__nav-next {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 4.84%, #FFFFFF 44.23%);
      z-index: 799;
    }
  }
}
.el-input {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  width: calc(100% - 80px);
  height: 40px;
  margin: 12px auto;
  box-sizing: border-box;
  background-color: #FFF;
  border-radius: 100px;
  z-index: 20;
  :deep(.el-input__wrapper) {
    padding: 8px 12px !important;
    border-radius: 100px !important;
    background-color: var(--background-light);
  }
}
.search-wrap {
  margin-top: 64px;
}
.select-wrap {
  :deep(.is-disabled) {
    --el-text-color-disabled: var(--text-primary);
    cursor: default !important;
  }
  :deep(.el-image) {
    width: 60px;
    height: 45px;
    border-radius: 8px;
    margin-right: 16px;
  }
  :deep(.collapse-selector) {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    padding: 8px 24px;
    width: 100%;
    height: auto;
    line-height: unset;
    box-sizing: border-box;
    font-weight: 500;
    color: var(--text-primary);
    &.hover, &:hover {
      background-color: transparent;
    }
    .option-left {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
    }
    span {
      font-size: 16px;
      line-height: 21px;
    }
    p {
      font-size: 12px;
      margin-top: 3px;
    }
    
    
    .el-radio {
      --el-radio-input-width: 18px;
      --el-radio-input-height: 18px;
      --el-radio-input-border-color-hover: var(--theme);
      .is-checked {
        .el-radio__inner {
          background: var(--theme);
          border: var(--theme);
          &::after {
            width: 6px;
            height: 6px;
          }
        }
      }
    }
    .el-radio__label {
      display: none;
    }
  }
  .single-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 24px;
    .radio {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
    }
    .checked-radio {
      border: 6px solid var(--theme);
    }
  }
  :deep(.collapse-selector) {
    justify-content: flex-start;
  }
  :deep(.el-collapse) {
    --el-collapse-header-height: auto;
    --el-text-color-placeholder: var(--text-primary);
    border: none;
    .el-collapse-item__header {
      border-bottom: none;
      .el-icon {
        width: 24px;
        height: 24px;
        margin-right: 24px;
      }
    }
    .el-collapse-item__wrap {
      border-bottom: none;
      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
    .el-collapse-item__arrow {
      transform: rotate(90deg);
    }
    .el-collapse-item__arrow.is-active {
      transform: rotate(-90deg);
    }
  }
  :deep(.collapse-selector) {
    cursor: pointer;
  }
  .circle-tab {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 14px 16px;
    background-color: #F9F9F9;
    span {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      height: 32px;
      font-size: 16px;
      line-height: 100%;
      padding: 0 16px;
      border: 1px solid var(--line);
      border-radius: var(--button-radius);
      cursor: pointer;
      margin: 16px 16px 0 0;
    }
    .active {
      color: var(--theme);
      border: 1px solid var(--theme);
    }
  }
  &-search {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 24px;
    background-color: #FFF;
    z-index: 999;
    :deep(.el-input__wrapper) {
      height: 40px;
      padding: 8px 12px;
      border-radius: 100px;
      background-color: var(--background-light);
    }
  }
  .recommeded-more {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 36px 24px 8px;
    cursor: pointer;
    font-size: 14px;
    color: var(--text-primary);
    box-sizing: border-box;
    &:hover {
      background: transparent;
    }
    .svg-icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
</style>

<style lang="postcss">
.circle-select-pop {
  background: var(--background-selection);
}
</style>